<div
  id="location-select"
  class="mt-4 pt-2 pt-md-4 ml-2 d-flex gap-1"
  *ngIf="showLocStrip">
  <ng-container *ngIf="userData?.selectedAccounts?.length === 1">
    <ng-container
      *ngTemplateOutlet="
        locationStripTemplate;
        context: { userData: userData?.selectedAccounts[0] }
      "></ng-container>
  </ng-container>
  <ng-container *ngIf="!userData?.selectedAccounts?.length">
    <ng-container
      *ngTemplateOutlet="
        locationStripTemplate;
        context: { userData: b2bUser }
      "></ng-container>
  </ng-container>
  <ng-container *ngIf="userData?.selectedAccounts?.length > 1">
    <ng-container
      *ngTemplateOutlet="
        multipleAccounts;
        context: { numberOfAccounts: userData?.selectedAccounts?.length }
      "></ng-container>
  </ng-container>
</div>

<ng-template #locationStripTemplate let-userData="userData">
  <i class="fa fa-map-marker-alt font-n mt-1"></i>
  <p class="d-flex flex-column">
    <span class="text-fixed-medium">
      {{ userData?.name }} {{ '(' + userData?.uid + ')' }}
    </span>

    <span *ngIf="userData?.shippingAddresses?.length > 0">
      <span>{{ userData?.shippingAddresses[0]?.line1 }}</span>
      <span>{{ userData?.shippingAddresses[0]?.postalCode }}</span>
    </span>
  </p>
</ng-template>

<ng-template #multipleAccounts let-numberOfAccounts="numberOfAccounts">
  <p>
    <i class="fa fa-map-marker-alt font-n"></i>
    <span class="px-3 text-fixed-medium">
      {{
        'location-strip.multi-account'
          | cxTranslate: { numberOfAccounts: numberOfAccounts }
      }}
    </span>
  </p>
</ng-template>
